module.exports=function(scope){ return `<div id="${scope.id}" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label ${scope.cls}">
    <input id="${scope.id}-input" class="mdl-textfield__input" type="${scope.type}" value="${scope.value}" ${scope.inputAttrs} ${scope.readonly} ${scope.required}>
    <label class="mdl-textfield__label" for="${scope.id}-input">${scope.label}</label>
    <span class="mdl-textfield__error">${scope.error}</span>
</div>`};